import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ec2682e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "automods" }
const _hoisted_2 = { class: "automod" }
const _hoisted_3 = { class: "automod-name text-truncate" }
const _hoisted_4 = { class: "automod-actions" }
const _hoisted_5 = { class: "automod-settings" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "punishment" }
const _hoisted_11 = { class: "automod-select" }
const _hoisted_12 = { class: "subtitle" }

import {computed, onMounted, Reactive, reactive, Ref, ref} from "vue";
import {GuildAutoModeration} from "@/types/GuildSettings";
import {Role} from "@/types/Role";
import i18n from "@/plugins/i18n";
import {useRoute} from "vue-router";
import DurationPicker from "@/components/DurationPicker.vue";
import SelectItems from "@/utils/SelectItems";
import {Channel} from "@/types/Channel";
import config from "@/config.json";
import AutoModInvitesOptions from "@/components/automod/options/AutoModInvitesOptions.vue";
import AutoModFloodOptions from "@/components/automod/options/AutoModFloodOptions.vue";
import TemplateInput from "@/components/TemplateInput.vue";
import TemplateCompilationError from "@/components/TemplateCompilationError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoModeration',
  props: {
    autoModeration: {},
    roles: {},
    channels: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
let autoModeration = props.autoModeration
let channels = SelectItems.channels(props.channels, false)
let whitelistRoles = SelectItems.roles(props.roles, false, false)
let whitelistChannels = SelectItems.channels(props.channels, false, false)
let dialogs: Reactive<Record<string, boolean>> = reactive({})
let valid: Reactive<Record<string, boolean>> = reactive({})
let loadingDisable: Reactive<Record<string, boolean>> = reactive({})
let loading: Reactive<Record<string, boolean>> = reactive({})
let certainChannels: Reactive<Record<string, boolean>> = reactive({})
let templateCompilationErrors: Reactive<Record<string, boolean>> = reactive({})
let punishments = computed(() => [
  {title: i18n.global.t('GuildModeration.punishments.warn'), value: 'warn'},
  {title: i18n.global.t('GuildModeration.punishments.mute'), value: 'mute'},
  {title: i18n.global.t('GuildModeration.punishments.kick'), value: 'kick'},
  {title: i18n.global.t('GuildModeration.punishments.ban'), value: 'ban'}
])

const reasonRules = [
  (reason: string) => (reason.length <= 512) || i18n.global.t('GuildModeration.errors.reasonLength')
]

for (let name of Object.keys(autoModeration)) {
  let automod = autoModeration[name as keyof typeof autoModeration]
  if (!automod.message?.enabled) automod.message = {enabled: false, channel: null, template: ''}
  if (!automod.punishment?.enabled) automod.punishment = {enabled: false, type: "warn", duration: 0, reason: ''}
  certainChannels[name] = Boolean(automod.message?.channel)
}

function certainChannelChange(name: string) {
  if (!certainChannels[name]) autoModeration[name as keyof typeof autoModeration].message!.channel = null
}

async function enable(name: string) {
  let automod = autoModeration[name as keyof typeof autoModeration]
  if(!automod.enabled) {
    automod.deleteMessages = true
    automod.options = {whitelistGuilds: [], messages: 20, symbols: 3000}
    automod.message = {enabled: false, channel: null, template: ''}
    automod.punishment = {enabled: false, type: 'warn', duration: 0, reason: ''}
    automod.whitelist = {roles: [], channels: []}
    dialogs[name] = true
  }
  else {
    loadingDisable[name] = true
    automod.enabled = false
    let response = await fetch(`${config.API}/private/guilds/${route.params.id}/automod/${name}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('token') as string
      },
      body: JSON.stringify(automod)
    })
    loadingDisable[name] = false
    if (response.ok) emit('update', 'success', autoModeration)
    else emit('update', 'error')
  }
}

async function submitAutomod(name: string) {
  templateCompilationErrors[name] = false;
  loading[name] = true;
  let automod = autoModeration[name as keyof typeof autoModeration]
  if (!automod.message?.template?.length) automod.message!.enabled = false
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/automod/${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token') as string
    },
    body: JSON.stringify(automod)
  })
  let body = await response.json()
  templateCompilationErrors[name] = body.message === "Template compilation error"
  loading[name] = false;
  if (response.ok) {
    dialogs[name] = false;
    emit('update', 'success', autoModeration)
  }
  else emit('update', 'error', autoModeration)
}

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(autoModeration), (automod, name) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`GuildModeration.autoModeration.${name}.name`)), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_switch, {
                modelValue: automod.enabled,
                "onUpdate:modelValue": ($event: any) => ((automod.enabled) = $event),
                class: "automod-enable",
                color: "primary",
                "hide-details": "",
                disabled: _unref(loadingDisable)[name],
                loading: _unref(loadingDisable)[name],
                onClick: ($event: any) => (enable(name))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "loading", "onClick"]),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                size: "small",
                disabled: !automod.enabled,
                onClick: ($event: any) => (_unref(dialogs)[name] = true)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "25" }, {
                    default: _withCtx(() => [
                      _createTextVNode("settings")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _unref(dialogs)[name],
              "onUpdate:modelValue": ($event: any) => ((_unref(dialogs)[name]) = $event),
              fullscreen: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { color: "modal" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar, {
                      dark: "",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          icon: "close",
                          disabled: _unref(loading)[name],
                          onClick: ($event: any) => (_unref(dialogs)[name] = false)
                        }, null, 8, ["disabled", "onClick"]),
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`GuildModeration.autoModeration.${name}.name`)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_toolbar_items, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              dark: "",
                              text: "",
                              disabled: _unref(valid)[name] === false,
                              loading: _unref(loading)[name],
                              onClick: ($event: any) => (submitAutomod(name))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  class: "btn-icon",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("save")
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildModeration.submit')), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "loading", "onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_form, {
                        modelValue: _unref(valid)[name],
                        "onUpdate:modelValue": ($event: any) => ((_unref(valid)[name]) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_unref(templateCompilationErrors)[name])
                            ? (_openBlock(), _createBlock(TemplateCompilationError, {
                                key: 0,
                                class: "error"
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_alert, {
                            class: "alert mb-2",
                            color: "alert",
                            border: "start",
                            title: _ctx.$t('GuildModeration.subtitles.description'),
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`GuildModeration.autoModeration.${name}.description`)), 1)
                            ]),
                            _: 2
                          }, 1032, ["title"]),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('GuildModeration.subtitles.options')), 1),
                          _createVNode(_component_v_checkbox, {
                            modelValue: automod.deleteMessages,
                            "onUpdate:modelValue": ($event: any) => ((automod.deleteMessages) = $event),
                            color: "primary",
                            density: "comfortable",
                            "hide-details": "",
                            label: _ctx.$t('GuildModeration.subtitles.deleteMessages')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                          (name === 'invites')
                            ? (_openBlock(), _createBlock(AutoModInvitesOptions, {
                                key: 1,
                                modelValue: automod.options,
                                "onUpdate:modelValue": ($event: any) => ((automod.options) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (name === 'flood')
                            ? (_openBlock(), _createBlock(AutoModFloodOptions, {
                                key: 2,
                                modelValue: automod.options,
                                "onUpdate:modelValue": ($event: any) => ((automod.options) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('GuildModeration.subtitles.actions')), 1),
                          _createVNode(_component_v_switch, {
                            modelValue: automod.message.enabled,
                            "onUpdate:modelValue": ($event: any) => ((automod.message.enabled) = $event),
                            class: "fit-content",
                            color: "primary",
                            "hide-details": "",
                            density: "compact",
                            label: _ctx.$t('GuildModeration.subtitles.message')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              (automod.message.enabled)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _unref(certainChannels)[name],
                                      "onUpdate:modelValue": ($event: any) => ((_unref(certainChannels)[name]) = $event),
                                      label: _ctx.$t('GuildModeration.subtitles.selectChannel'),
                                      "hide-details": "",
                                      density: "comfortable",
                                      color: "primary",
                                      onChange: ($event: any) => (certainChannelChange(name))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onChange"]),
                                    _createVNode(_component_v_expand_transition, null, {
                                      default: _withCtx(() => [
                                        (_unref(certainChannels)[name])
                                          ? (_openBlock(), _createBlock(_component_v_select, {
                                              key: 0,
                                              modelValue: automod.message.channel,
                                              "onUpdate:modelValue": ($event: any) => ((automod.message.channel) = $event),
                                              class: "automod-select",
                                              color: "primary",
                                              items: _unref(channels),
                                              label: _ctx.$t('GuildModeration.subtitles.channel')
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(TemplateInput, {
                                      modelValue: automod.message.template,
                                      "onUpdate:modelValue": ($event: any) => ((automod.message.template) = $event),
                                      variables: ['member', 'guild', 'channel'],
                                      counter: 1500
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_switch, {
                            modelValue: automod.punishment.enabled,
                            "onUpdate:modelValue": ($event: any) => ((automod.punishment.enabled) = $event),
                            class: "fit-content",
                            color: "primary",
                            "hide-details": "",
                            density: "compact",
                            label: _ctx.$t('GuildModeration.subtitles.punishMember')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              (automod.punishment.enabled)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_component_v_select, {
                                          modelValue: automod.punishment.type,
                                          "onUpdate:modelValue": ($event: any) => ((automod.punishment.type) = $event),
                                          color: "primary",
                                          items: _unref(punishments),
                                          label: _ctx.$t('GuildModeration.subtitles.punishment')
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"])
                                      ]),
                                      (['mute', 'ban'].includes(automod.punishment.type))
                                        ? (_openBlock(), _createBlock(DurationPicker, {
                                            key: 0,
                                            limit: 315360000000,
                                            modelValue: automod.punishment.duration,
                                            "onUpdate:modelValue": ($event: any) => ((automod.punishment.duration) = $event),
                                            class: "punishment-duration"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: automod.punishment.reason,
                                      "onUpdate:modelValue": ($event: any) => ((automod.punishment.reason) = $event),
                                      class: "general-item-field",
                                      color: "primary",
                                      counter: "512",
                                      rules: reasonRules,
                                      label: _ctx.$t('GuildModeration.subtitles.reason')
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('GuildModeration.subtitles.whitelist')), 1),
                          _createVNode(_component_v_select, {
                            modelValue: automod.whitelist.roles,
                            "onUpdate:modelValue": ($event: any) => ((automod.whitelist.roles) = $event),
                            class: "whitelist-select",
                            color: "primary",
                            items: _unref(whitelistRoles),
                            multiple: "",
                            chips: "",
                            "closable-chips": "",
                            label: _ctx.$t('GuildModeration.subtitles.allowedRoles')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"]),
                          _createVNode(_component_v_select, {
                            modelValue: automod.whitelist.channels,
                            "onUpdate:modelValue": ($event: any) => ((automod.whitelist.channels) = $event),
                            class: "whitelist-select",
                            color: "primary",
                            items: _unref(whitelistChannels),
                            multiple: "",
                            chips: "",
                            "closable-chips": "",
                            label: _ctx.$t('GuildModeration.subtitles.allowedChannels')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]),
            (Object.keys(_unref(autoModeration)).indexOf(name) < Object.keys(_unref(autoModeration)).length-1)
              ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ])
    ])
  ]))
}
}

})